import { globalRouter } from '@/router'
import { getUserRoutes } from '@/api/login'
import store from '../index'
import { apiGetLwgBB } from '@/api/sap/client-sap'
import { getToken, setToken, clearToken } from '@/utils/auth'
import Layout from '@/layout'
const _import = require('@/utils/_import_' + process.env.NODE_ENV)
import { isExternal } from '@/utils/validate'
import { Message } from 'element-ui'
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
// 主要递归出菜单
export function filterAsyncRoutes(routes, parentPath = '/wly') {
  const res = []
  if (!routes || !routes.length) {
    return res
  }
  routes.forEach(route => {
    const tmp = { ...route }
    const r = {}
    if (isExternal(tmp.metas.path)) {
      r.path = tmp.metas.path
    } else {
      r.path = `${parentPath}${tmp.metas.path}`
    }
    if (tmp.metas.hidden === 'true' && tmp.metas.component === 'Layout') {
      return
    }
    r.hidden = tmp.metas.hidden === 'true'
    r.name = tmp.name
    r.code = tmp.code // 保存菜单编码到路由对象顶层，用于过滤一级菜单
    r.meta = {
      title: tmp.name,
      icon: tmp.metas.icon,
      id: tmp.id,
      keepAlive: tmp.metas.keepalive || false,
      islink: tmp.metas.islink || false
    }
    if (tmp.children) {
      r.children = filterAsyncRoutes(tmp.children, r.path)
    }
    res.push(r)
  })
  return res
}

// 扁平化路由解决keep-alive不能缓存三级路由问题
const filterRoutes = (routes, parentPath = '/wly') => {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    const r = {}
    if (isExternal(tmp.metas.path)) {
      r.path = tmp.metas.path
    } else {
      r.path = `${parentPath}${tmp.metas.path}`
    }
    r.hidden = tmp.metas.hidden === 'true'
    r.name = tmp.name
    r.code = tmp.code // 保存菜单编码到路由对象顶层，用于过滤一级菜单
    r.meta = {
      title: tmp.name,
      icon: tmp.metas.icon,
      id: tmp.id,
      keepAlive: tmp.metas.keepalive || false,
      islink: tmp.metas.islink || false
    }
    if (tmp.metas.component) {
      if (tmp.metas.component === 'Layout') {
        r.component = Layout
      } else if (tmp.metas.component === 'routerView') {
        // 检查是否还有 下级路由
        if (tmp.children) {
          // 三级路由
          res.push(...filterRoutes(tmp.children, r.path))
          return res
        }
      } else {
        try {
          r.component = _import(tmp.metas.component)
        } catch (error) {
          console.error('接口设置的加载组件在导出项目views/ 不存在  error-> component', tmp.metas.component)
        }
      }
    }
    if (tmp.children) {
      r.children = filterRoutes(tmp.children, r.path)
    }
    res.push(r)
  })
  return res
}

const insertYHReportForms = async(routes, data) => {
  // 如果有要货模块直接添加
  const yhRoute = routes.find(route => route.path === '/wly/to-goods' && route.name === '140 要货管理')
  if (yhRoute) {
    // 是否有要货报表路由
    const rpformRoute = yhRoute.children.find(route => route.path === '/wly/to-goods/yhreport')
      if (rpformRoute) {
      data.forEach((route,index) => {
        let arr = []
        route.children.forEach(ele => {
          arr.push({
            path: ele.linkaddress,
            name: ele.infocustomname,
            hidden: false,
            meta: {
              title: ele.infocustomname,
              icon: '',
              id: new Date().getTime(),
              keepAlive: false,
              islink: true
            }
          })
        });
        rpformRoute.children.push({
          children: arr,
          path: route.linkaddress,
          name: route.infocustomname,
          hidden: false,
          meta: {
            title: route.infocustomname,
            icon: '',
            id: new Date().getTime(),
            keepAlive: false,
            islink: true
          }
        })
      })
    } else {
      const rpformRoute = {
        path: '/wly/to-goods/yhreport',
        name: '140.04 老要货报表',
        hidden: false,
        children: [],
        meta: {
          title: '140.04 老要货报表',
          icon: '',
          id: new Date().getTime(),
          keepAlive: false,
          islink: false
        }
      }
      yhRoute.children.push(rpformRoute)
      data.forEach(route => {
        rpformRoute.children.push({
          path: route.linkaddress,
          name: route.infocustomname,
          hidden: false,
          meta: {
            title: route.infocustomname,
            icon: '',
            id: new Date().getTime(),
            keepAlive: false,
            islink: true
          }
        })
      })
    }
  }
}

const getOldYHReportForms = async() => {
  return await apiGetLwgBB({
    user_bp: store.getters.role.USER_BP
  })
}

const state = {
  routes: [],
  addRoutes: [],
  token: getToken(),
  buttonPer: {},
  menuCode: null // 一级菜单编码，用于过滤菜单
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = globalRouter.concat(routes)
  },
  SET_BUTTONS: (state, buttons) => {
    state.buttonPer = buttons
  },
  RESET_BUTTONS: (state) => {
    state.buttonPer = {}
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  RESET_ROUTES: (state) => {
    state.routes = []
  },
  SET_MENU_CODE: (state, menuCode) => {
    state.menuCode = menuCode
  },
  RESET_MENU_CODE: (state) => {
    state.menuCode = null
  }
}

const actions = {
  generateRoutes({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      getUserRoutes().then(async({ data }) => {
        if (data.routes && data.routes.length > 0) {
          const { data: yhRoutes } = await getOldYHReportForms()

          // 根据 menuCode 过滤 routes[0].children
          let filteredChildren = data.routes[0].children || []
          const menuCode = state.menuCode
          if (menuCode) {
            // 只保留 code 匹配 menuCode 的一级菜单
            filteredChildren = filteredChildren.filter(child => {
              if (child.code) {
                return String(child.code) === String(menuCode) || child.code === menuCode
              }
              return false
            })
          }

          // 路由
          const accessedRoutes = filterRoutes(filteredChildren)
          accessedRoutes.push({
            path: '*',
            redirect: '/404',
            meta: {},
            hidden: true
          })
          const routes = filterAsyncRoutes(filteredChildren)
          if (yhRoutes.length) {
            await insertYHReportForms(routes, yhRoutes)
          }
          commit('SET_ROUTES', routes)
          resolve(accessedRoutes)
        } else {
          Message.error('该角色没有分配页面权限！')
          reject()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      clearToken()
      resolve()
    })
  },
  setToken({ commit }, token) {
    return new Promise(resolve => {
      commit('SET_TOKEN', token)
      setToken(token)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/permission.js